const accordeon = () => {
  const triggers = document.querySelectorAll('.accordeon__trigger');
  if (!triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const panelId  = trigger.getAttribute('aria-controls');
      const panel    = document.getElementById(panelId);

      if (!panel) return;

      trigger.setAttribute('aria-expanded', String(!expanded));

      if (!expanded) {
        panel.removeAttribute('hidden');
        panel.dataset.open = 'true';
      } else {
        panel.dataset.open = 'false';

        // wait for animation to finish, then hide
        setTimeout(() => {
          panel.setAttribute('hidden', '');
        }, 300);
      }
    });
  });
};

export default accordeon;
